import { PAGE_PERMISSIONS } from '@/constants/permissions';
import { HARVEST_ROUTES, ROUTES } from '@/constants/routes';
import { MainLayout } from '@/layouts/MainLayout';
import { PermissionRoute } from '@/layouts/PermissionRoute';
import { NotFound } from '@/pages/404';
// import { Agrosubsidiya } from '@/pages/agrosubsidiya/Agrosubsidiya';
import { Auth } from '@/pages/auth';
import { HarvestClusterDetails } from '@/pages/harvest/HarvestClusterDetails';
import { HarvestClusters } from '@/pages/harvest/HarvestClusters';
import { Insurance } from '@/pages/insurance/Insurance';
import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const Agroportal = lazy(() =>
  import('@/pages/agroportal').then((m) => ({ default: m.Agroportal })),
);
const Agrosubsidiya = lazy(() =>
  import('@/pages/agrosubsidiya').then((m) => ({ default: m.Agrosubsidiya })),
);
const Bank = lazy(() =>
  import('@/pages/bank').then((m) => ({ default: m.Bank })),
);
const Burse = lazy(() =>
  import('@/pages/burse').then((m) => ({ default: m.Burse })),
);
const HarvestLayout = lazy(() =>
  import('@/pages/harvest').then((m) => ({ default: m.HarvestLayout })),
);
const Harvest = lazy(() =>
  import('@/pages/harvest').then((m) => ({ default: m.Harvest })),
);
const HarvestLocations = lazy(() =>
  import('@/pages/harvest').then((m) => ({ default: m.HarvestLocations })),
);
// Klasterlar sahifasi hozircha yopiq — tayyor bo'lgach ochiladi.
// const HarvestClusterDetails = lazy(() =>
//   import('@/pages/harvest').then((m) => ({ default: m.HarvestClusterDetails })),
// );
// const HarvestClusters = lazy(() =>
//   import('@/pages/harvest').then((m) => ({ default: m.HarvestClusters })),
// );
const HarvestLocationDetails = lazy(() =>
  import('@/pages/harvest').then((m) => ({
    default: m.HarvestLocationDetails,
  })),
);
const Land = lazy(() =>
  import('@/pages/lands').then((m) => ({ default: m.Land })),
);
const MaterialControl = lazy(() =>
  import('@/pages/material-control').then((m) => ({
    default: m.MaterialControl,
  })),
);
const CosmicMonitoring = lazy(() =>
  import('@/pages/cosmic-monitoring').then((m) => ({
    default: m.CosmicMonitoring,
  })),
);
const RolesPage = lazy(() =>
  import('@/pages/Roles').then((m) => ({ default: m.RolesPage })),
);
const SeedsPage = lazy(() =>
  import('@/pages/seeds').then((m) => ({ default: m.SeedsPage })),
);
const CreateRolePage = lazy(() =>
  import('@/pages/Roles').then((m) => ({ default: m.CreateRolePage })),
);
const ProfilePage = lazy(() =>
  import('@/pages/profile').then((m) => ({ default: m.ProfilePage })),
);
const UsersPage = lazy(() => import('@/pages/Users'));
const CreateUserPage = lazy(() => import('@/pages/Users/CreateUserPage'));

export const router = (): RouteObject[] => {
  return [
    {
      path: ROUTES.AUTH,
      element: <Auth />,
    },
    {
      path: ROUTES.HOME,
      element: <MainLayout />,
      children: [
        {
          index: true,
          element: <Navigate to={ROUTES.PROFILE} replace />,
        },
        {
          path: ROUTES.PROFILE,
          element: <ProfilePage />,
        },
        {
          path: ROUTES.LAND_AREA,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.LAND}>
              <Land />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.HARVEST,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.HARVEST}>
              <HarvestLayout />
            </PermissionRoute>
          ),
          children: [
            {
              index: true,
              element: <Navigate to={HARVEST_ROUTES.STATISTICS} replace />,
            },
            { path: HARVEST_ROUTES.STATISTICS, element: <Harvest /> },
            { path: HARVEST_ROUTES.LOCATIONS, element: <HarvestLocations /> },
            {
              path: HARVEST_ROUTES.LOCATION_DETAILS,
              element: <HarvestLocationDetails />,
            },
            { path: HARVEST_ROUTES.CLUSTERS, element: <HarvestClusters /> },
            {
              path: HARVEST_ROUTES.CLUSTER_DETAILS,
              element: <HarvestClusterDetails />,
            },
          ],
        },
        {
          path: ROUTES.COSMIC_MONITORING,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.COSMIC_MONITORING}>
              <CosmicMonitoring />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.BIRJA,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.BURSE}>
              <Burse />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.BANK,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.BANK}>
              <Bank />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.AGROPORTAL,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.AGROPORTAL}>
              <Agroportal />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.AGROSUBSIDIYA,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.AGROSUBSIDIYA}>
              <Agrosubsidiya />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.INSURANCE,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.INSURANCE}>
              <Insurance />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.MATERIAL_CONTROL,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.MATERIAL_CONTROL}>
              <MaterialControl />
            </PermissionRoute>
          ),
        },
        {
          path: ROUTES.SEEDS,
          element: (
            <PermissionRoute permissions={PAGE_PERMISSIONS.SEEDS}>
              <SeedsPage />
            </PermissionRoute>
          ),
        },
        {
          path: 'users',
          children: [
            {
              index: true,
              element: (
                <PermissionRoute permissions={PAGE_PERMISSIONS.USERS.INDEX}>
                  <UsersPage />
                </PermissionRoute>
              ),
            },
            {
              path: 'create',
              element: (
                <PermissionRoute permissions={PAGE_PERMISSIONS.USERS.CREATE}>
                  <CreateUserPage />
                </PermissionRoute>
              ),
            },
            {
              path: 'edit/:id',
              element: (
                <PermissionRoute permissions={PAGE_PERMISSIONS.USERS.EDIT}>
                  <CreateUserPage />
                </PermissionRoute>
              ),
            },
          ],
        },

        {
          path: 'roles',
          children: [
            {
              index: true,
              element: (
                <PermissionRoute permissions={PAGE_PERMISSIONS.ROLES.INDEX}>
                  <RolesPage />
                </PermissionRoute>
              ),
            },
            {
              path: 'create',
              element: (
                <PermissionRoute permissions={PAGE_PERMISSIONS.ROLES.CREATE}>
                  <CreateRolePage />
                </PermissionRoute>
              ),
            },
            {
              path: 'edit/:id',
              element: (
                <PermissionRoute permissions={PAGE_PERMISSIONS.ROLES.EDIT}>
                  <CreateRolePage />
                </PermissionRoute>
              ),
            },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ];
};
